import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/themeFour/circleBot.png'
import _imports_1 from '@/assets/themeFour/maskBox.png'
import _imports_2 from '@/assets/themeFour/circle.png'
import _imports_3 from '@/assets/themeFour/pandaImg.png'
import _imports_4 from '@/assets/bonus/smactv2_btn_notstart.png'
import _imports_5 from '@/assets/themeFour/tittleIcon.png'


const _hoisted_1 = { class: "mainContainer" }
const _hoisted_2 = { class: "page_main_title" }
const _hoisted_3 = { class: "amount_wrapper" }
const _hoisted_4 = { class: "buttonFooter inline_button" }
const _hoisted_5 = { class: "day_row" }
const _hoisted_6 = { style: {"padding":"0 15px 15px"} }
const _hoisted_7 = {
  key: 0,
  class: "details_card"
}
const _hoisted_8 = { class: "date_details" }
const _hoisted_9 = {
  class: "amount_wrapper",
  style: {"min-height":"80px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"}
}
const _hoisted_10 = { class: "amount" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "misterio_text"
}
const _hoisted_13 = {
  key: 2,
  class: "misterio",
  style: {"margin-top":"0"}
}
const _hoisted_14 = { class: "middleCardTop" }
const _hoisted_15 = { class: "middleTop" }
const _hoisted_16 = {
  key: 0,
  class: "tabel_container"
}
const _hoisted_17 = {
  key: 1,
  class: "bottom_text"
}
const _hoisted_18 = { class: "ruleHeader" }
const _hoisted_19 = { class: "tittle" }

import { formatCurrency, formatUnixTimestamp } from '@/utils/commonFunction';
import { ref } from 'vue';
import { BonusData, calculateValue, MYSTERIO_IMG_THREE } from '@/view/bonus/supportScript';
import CustomHeader from '../components/common/customHeader.vue';
import BonusTracker from './BonusTracker.vue';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusView',
  props: {
    dataSet: {}
  },
  emits: ['pickMisteryGift', 'selectTab'],
  setup(__props: any, { emit: __emit }) {

const mysterioImages = ref(MYSTERIO_IMG_THREE)
const router = useRouter()
const props = __props

const emits = __emit

const pickMisteryGift = (activeStatus: number) => {
    emits('pickMisteryGift', activeStatus)
}

const selectTab = (item: any) => {
    emits('selectTab', item)
}



return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(CustomHeader, {
        text: _ctx.$t('bonus.mysterybonus'),
        bgColor: "#002d2d"
      }, null, 8, ["text"]),
      _cache[3] || (_cache[3] = _createTextVNode(": ")),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('bonus.pageTitle')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(['topamount', { 'is-transparent': !(_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 0 || (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 1 && _ctx.dataSet.selectedTab?.reward_data?.rewardCoin)) }])
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "currency-badge" }, "R$", -1)),
          _createTextVNode(" " + _toDisplayString(_unref(formatCurrency)(_ctx.dataSet.selectedTab?.reward_data?.rewardCoin || 0)), 1)
        ], 2)
      ]),
      _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"mystery_visual_wrapper\" data-v-57a12779><img src=\"" + _imports_0 + "\" class=\"layer base_plate\" data-v-57a12779><img src=\"" + _imports_1 + "\" class=\"layer mystery_chest\" data-v-57a12779><img src=\"" + _imports_2 + "\" class=\"layer glass_dome\" data-v-57a12779><img src=\"" + _imports_3 + "\" class=\"layer panda_character\" data-v-57a12779></div>", 1)),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_row, null, {
          default: _withCtx(() => [
            (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 0 && !_ctx.dataSet.selectedTab?.reward_data?.rewardCoin)
              ? (_openBlock(), _createBlock(_component_van_col, {
                  key: 0,
                  span: "24",
                  class: "start_img"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_icon, {
                      name: "checked",
                      color: "#66d329",
                      size: "18px",
                      style: {"margin-right":"8px"}
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('activityStatus.expired')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 0 && _ctx.dataSet.selectedTab?.reward_data?.rewardCoin)
              ? (_openBlock(), _createBlock(_component_van_col, {
                  key: 1,
                  span: "24",
                  class: "statusBar",
                  style: {"color":"#66d329"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('activityStatus.completed')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 1 && !_ctx.dataSet.selectedTab?.reward_data?.rewardCoin)
              ? (_openBlock(), _createBlock(_component_van_col, {
                  key: 2,
                  span: "24",
                  class: "start_img2"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _imports_4,
                      alt: "",
                      class: _normalizeClass({ 'pop-animate': _ctx.dataSet.isPopping }),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (pickMisteryGift(_ctx.dataSet.selectedTab?.reward_data?.activeStatus)))
                    }, null, 2)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 1 && _ctx.dataSet.selectedTab?.reward_data?.rewardCoin)
              ? (_openBlock(), _createBlock(_component_van_col, {
                  key: 3,
                  span: "24",
                  class: "statusBar",
                  style: {"color":"#66d329"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('activityStatus.completed')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 2)
              ? (_openBlock(), _createBlock(_component_van_col, {
                  key: 4,
                  span: "24",
                  class: "statusBar",
                  style: {"color":"black"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('rewards.notActivated')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(BonusTracker, {
          dayList: _ctx.dataSet.dayList,
          activeDay: _ctx.dataSet.selectedTab?.reward_day,
          onSelect: selectTab
        }, null, 8, ["dayList", "activeDay"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.dataSet.selectedTab)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_van_row, { class: "details_content" }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, { span: "24" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_row, { class: "middleCard" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_van_col, {
                            span: "24",
                            class: "text_1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('bonus.claimTime')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_van_col, { span: "24" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(formatUnixTimestamp)(_ctx.dataSet.selectedTab?.reward_data?.rewardTime)), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_van_col, {
                            span: "24",
                            class: "combined_amount_row"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                  (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 0 || (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 1 && _ctx.dataSet.selectedTab?.reward_data?.rewardCoin))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "currency-badge" }, "R$", -1)),
                                        _createTextVNode(" " + _toDisplayString(_unref(formatCurrency)(_ctx.dataSet.selectedTab?.reward_data?.rewardCoin || 0)), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('bonus.mysterybonus')), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 2 || (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 1 && !_ctx.dataSet.selectedTab?.reward_data?.rewardCoin))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('rewards.notActivated')), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_van_row, { class: "info_row" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_col, {
                        span: "2",
                        class: "icon_col"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_van_icon, { name: "clock-o" })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_col, {
                        span: "12",
                        class: "label_text"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('bonus.registrationTime')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_col, {
                        span: "10",
                        class: "value_text",
                        style: {"font-weight":"500"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(formatUnixTimestamp)(_ctx.dataSet.mysteryDataConfig?.config?.user_join_date)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_row, { class: "info_row" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_col, {
                        span: "2",
                        class: "icon_col"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_van_icon, { name: "points" })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_col, {
                        span: "13",
                        class: "label_text"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('bonus.totalDeposit')) + " " + _toDisplayString(_ctx.dataSet.selectedTab?.reward_day) + _toDisplayString(_ctx.$t('common.days')) + ":", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_col, {
                        span: "9",
                        class: "value_text",
                        style: {"font-weight":"500"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("R$" + _toDisplayString(_unref(formatCurrency)(_ctx.dataSet.selectedTab?.reward_data?.rechargeCoin
                                    || 0)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.dataSet.selectedTab)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_component_van_row, { class: "tabel_hed" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "12",
                class: "head_alignemnet"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('bonus.depostiScope')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "12",
                class: "head_alignemnet"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('bonus.mysteryPrize')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.selectedTab?.reward_data?.reward_day_data, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_row, {
              class: "tabel_row",
              key: index
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => [
                    _cache[5] || (_cache[5] = _createTextVNode("R$ ")),
                    _createElementVNode("span", null, _toDisplayString(item.recharge_min < 0 ? '\u221E' : _unref(formatCurrency)(_unref(calculateValue)(item.recharge_min))) + " ~ " + _toDisplayString(item.recharge_max < 0 ? '\u221E' : _unref(formatCurrency)(_unref(calculateValue)(item.recharge_max))), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "head_alignemnet currencyText"
                }, {
                  default: _withCtx(() => [
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "currency-prefix" }, "R$", -1)),
                    _createElementVNode("span", null, _toDisplayString(item.show_reward_min < 0 ? '\u221E' :
                        _unref(formatCurrency)(_unref(calculateValue)(item.show_reward_min))) + " ~ " + _toDisplayString(item.show_reward_max < 0
                                ? '\u221E' : _unref(formatCurrency)(_unref(calculateValue)(item.show_reward_max))), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.dataSet.activityInfo.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_van_row, { style: {"padding-bottom":"10px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "24",
                class: "title"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_18, [
                    _cache[7] || (_cache[7] = _createElementVNode("img", {
                      class: "side-icon",
                      src: _imports_5
                    }, null, -1)),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('common.eventRule')), 1),
                    _cache[8] || (_cache[8] = _createElementVNode("img", {
                      class: "side-icon flipped",
                      src: _imports_5
                    }, null, -1))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.activityInfo, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "line_text",
              key: index
            }, _toDisplayString(item), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})